import { Injectable } from '@angular/core';
import { WindorefService } from 'src/app/services/window/windoref.service';
import { GlobalsService } from 'src/app/services/globals/globals.service';
import { LogService } from 'src/app/services/log/log.service';
import { Logtype } from 'src/app/enums/log/logtype.enum';

@Injectable({
  providedIn: 'root'
})
export class EmarsysService {
  constructor(private _winRef: WindorefService, private _logService: LogService, private _globalService: GlobalsService) {}

  loadEmarsys() {
    const script = this._winRef.getNativeWindow().document.createElement('script');
    script.type = 'text/javascript';
    script.textContent = 'var ScarabQueue = ScarabQueue || [];';
    script.defer = true;
    script.async = false;
    this._winRef.getNativeWindow().document.getElementsByTagName('head')[0].appendChild(script);
    this._logService.createLog(Logtype.INFO, 'ScarabQueue initialized', this.constructor.toString().match(/\w+/g)[1], 'emarsysTrack');
    this.loadScript();
  }

  loadScript() {
    let system: string = this._globalService.getSystem().site;
    let account: string = system === 'wt' ? '1C6FD5A437FF1079' : '10DFAC82F157EFAA';
    const script = this._winRef.getNativeWindow().document.createElement('script');
    script.id = 'scarab-js-api';
    script.type = 'text/javascript';
    script.src = `https://cdn.scarabresearch.com/js/${account}/scarab-v2.js`;
    script.defer = true;
    script.async = false;
    this._winRef.getNativeWindow().document.getElementsByTagName('head')[0].appendChild(script);
    this._logService.createLog(Logtype.INFO, 'ScarabQueue script instanced', this.constructor.toString().match(/\w+/g)[1], 'emarsysTrack');
  }

  launchGo() {
    const script = this._winRef.getNativeWindow().document.createElement('script');
    script.type = 'text/javascript';
    script.async = false;
    script.defer = true;
    script.textContent = "ScarabQueue.push(['go']);";
    this._winRef.getNativeWindow().document.getElementsByTagName('head')[0].appendChild(script);
    this._logService.createLog(Logtype.INFO, 'ScarabQueue event GO has been launched', this.constructor.toString().match(/\w+/g)[1], 'emarsysTrack');
  }
}
